<template>
    <b-dropdown-item
        @click="handleClick"
        :id="item.function_code ? 'link-' + item.function_code : 'link'"
    >
        <div class="dropdown-nested-item">
            <i :class="item.icon"></i>
            {{ item.text }}
        </div>
    </b-dropdown-item>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    methods: {
        handleClick(event) {
            // if current menu item triggers a modal/dialog,
            // then we should put a "stop" to prevent redirection to its parent tab.
            // Opening a modal (from different tab) should not
            // redirect users to the its tab.
            if (this.item.isModal) {
                event.stopPropagation();
            }

            this.$emit("click");
        }
    }
};
</script>
